import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { SubmitButton } from "../../components/Input";
import { showToast } from "../../components/toast";

const InvestorCharterForm = ({ id, data }) => {
  const { id: paramId } = useParams();
  const navigate = useNavigate();
  const editId = id || paramId;

  const [rows, setRows] = useState(data || []);
  const [monthEndingTitle, setMonthEndingTitle] = useState("");

  useEffect(() => {
    if (data && data.inv_month_ending) {
      setMonthEndingTitle(data.inv_month_ending);
    }
  }, [data]);

  const handleAddRow = () => {
    const newRow = {
      id: rows.length + 1, // New row ID based on the length of current rows
      received_from: '',
      pending_last_month: '',
      received: '',
      resolved: '',
      total_pending: '',
      pending_three_months: '',
      average_time: '',
      month: '',
      carried_month: '',
      pending: '',
      year: '',
      carried_year: ''
    };

    setRows([...rows, newRow]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!monthEndingTitle.trim()) {
      showToast.error("Please enter Month Ending Title");
      return;
    }

    showToast.success(
      editId
        ? "Investor Charter updated successfully!"
        : "Investor Charter saved successfully!"
    );
    navigate("/Settings/InvestorCharter");
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="row pb-2">
          <div className="col-md-6">
            <h4 className="panel-title pull-left">
              {editId ? "Edit Investor Charter" : "Add Investor Charter"}
            </h4>
          </div>
          <div className="col-md-6 text-right">
            <Link
              to="/Settings/InvestorCharter"
              className="btn btn-default btn-sm"
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Back
            </Link>
          </div>
        </div>

        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0">
            <span className="panel-title">
              {editId ? "Edit Investor Charter" : "Investor Charter Form"}
            </span>
          </div>
          <div className="panel-body">
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="form-group col-md-6">
                  <label htmlFor="monthEndingTitle">
                    <strong>Month Ending Title</strong>{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="monthEndingTitle"
                    name="monthEndingTitle"
                    value={monthEndingTitle}
                    onChange={(e) => setMonthEndingTitle(e.target.value)}
                    required
                    placeholder="Enter Month Ending Title"
                  />
                </div>
              </div>

              <div className="table-responsive col-md-12 mb-3">
                <table className="table table-bordered m-b-0">
                  <thead>
                    <tr className="bg-light">
                      <th style={{ textAlign: "center", width: "25%" }}>
                        Received From
                      </th>
                      <th style={{ textAlign: "center", width: "12%" }}>
                        Pending Last Month
                      </th>
                      <th style={{ textAlign: "center", width: "10%" }}>
                        Received
                      </th>
                      <th style={{ textAlign: "center", width: "10%" }}>
                        Resolved*
                      </th>
                      <th style={{ textAlign: "center", width: "10%" }}>
                        Total Pending#
                      </th>
                      <th style={{ textAlign: "center", width: "15%" }}>
                        Pending Complaints 3 months
                      </th>
                      <th style={{ textAlign: "center", width: "13%" }}>
                        Average Resolution Time (in days)
                      </th>
                      <th style={{ textAlign: "center", width: "5%" }}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length > 0 ? (
                      rows.map((row, index) => (
                        <tr key={row.id || index}>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="received_from"
                              value={row.received_from}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="e.g. Directly from Investors"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="pending_last_month"
                              value={row.pending_last_month}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="0"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="received"
                              value={row.received}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="0"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="resolved"
                              value={row.resolved}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="0"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="total_pending"
                              value={row.total_pending}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="0"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="pending_three_months"
                              value={row.pending_three_months}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="0"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <input
                              type="text"
                              className="form-control input-sm"
                              name="average_time"
                              value={row.average_time}
                              onChange={(e) => handleInputChange(index, e)}
                              placeholder="0"
                            />
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <button
                              type="button"
                              className="btn btn-danger btn-xs"
                              onClick={() => handleRemoveRow(index)}
                              title="Delete Record"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center text-muted">
                          No rows added. Click "Add Data" to add a row.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 mb-3">
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={handleAddRow}
                >
                  <FontAwesomeIcon icon={faPlus} /> Add Data
                </button>
              </div>

              <input type="hidden" name="cloop" value={rows.length} />
              <div className="col-md-12">
                <SubmitButton
                  pageBack="/Settings/InvestorCharter"
                  handleSubmit={handleSubmit}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorCharterForm;
